import { render, staticRenderFns } from "./NestFormItemEditor.vue?vue&type=template&id=0a2b95a4&scoped=true&"
import script from "./NestFormItemEditor.vue?vue&type=script&lang=js&"
export * from "./NestFormItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./NestFormItemEditor.vue?vue&type=style&index=0&id=0a2b95a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b95a4",
  null
  
)

export default component.exports